// @ts-nocheck
import {categoryOptions} from '@/molecules/Fragments/Filters/Category/content';
import {styleOptions} from '@/molecules/Fragments/Filters/Style/content';
import {subjectOptions} from '@/molecules/Fragments/Filters/Subject/content';
import {EditorsPicksProps, LinkProps} from '@/organisms/Navigation/typings';
import {CurrencySymbol} from '@/redux/reducers/typings';
import i18next from 'i18next';

export const sharedNavigationMap = (
  editorsPicks: EditorsPicksProps[],
  currencySymbol: CurrencySymbol = '£',
): LinkProps[] => {
  return [
    {
      text: 'all art',
      link: '/art/',
    },
    ...categoryOptions.map((category) => ({
      text: category.label,
      link: `/art/product_category-${category.value}/`,
      submenu: [
        {
          title: 'Subject',
          links: subjectOptions.map((subject) => ({
            text: subject.label,
            link: `/art/product_category-${category.value}/subject-${subject.value}/`,
          })),
        },
        ...(category.suboptions
          ? category.groups
            ? category.groups.map((group) => ({
                title: group.label,
                links: group.suboptions.map((suboption) => ({
                  text: suboption.label,
                  link: `/art/product_category-${category.value}/${category.value}-${suboption.value}/`,
                })),
              }))
            : [
                {
                  title: 'Medium',
                  links: category.suboptions.map((suboption) => ({
                    text: suboption.label,
                    link: `/art/product_category-${category.value}/${category.value}-${suboption.value}/`,
                  })),
                },
              ]
          : []),
        {
          title: 'Style',
          links: styleOptions
            .filter((style) => !style.filtersOnly)
            .map((style) => ({
              text: style.label,
              link: `/art/product_category-${category.value}/style-${style.value}/`,
            })),
        },
        {
          links: [
            {
              text: `${i18next.t(`categories.${category.label}`, {count: 2, defaultValue: category.label})} on sale`,
              link: `/art/product_category-${category.value}/in_sale-on/`,
            },
            {
              text: `${i18next.t(`categories.${category.label}`, {count: 2, defaultValue: category.label})} under ${currencySymbol}500`,
              link: `/art/product_category-${category.value}/price_max-500/`,
            },
          ],
          highlights: [
            {
              text: `Browse all ${i18next.t(`categories.${category.label}`, {count: 2, defaultValue: category.label})}`,
              link: `/art/product_category-${category.value}/`,
            },
          ],
        },
      ],
    })),
    {
      text: 'inspiration',
      link: '/editors-picks/',
      submenu: [
        {
          title: 'Editors’ Picks',
          links: editorsPicks.map((pick) => ({text: pick.name, link: pick.url})),
          highlights: [{text: `All editors' picks`, link: '/editors-picks/'}],
        },
        {
          title: 'Artists',
          links: [
            {
              text: 'Bestsellers',
              link: '/artist-charts/top-40-artists/',
            },
            {
              text: 'Artists of the month',
              link: '/staff-picks/artists-of-the-month/',
            },
            {
              text: 'Trending artists',
              link: '/blog/category/trending-artists/',
            },
            {
              text: 'Commission an artist',
              link: '/artist-search/sort-best_match/paginate-60/acceptscommissions-true/',
            },
          ],
          highlights: [
            {
              text: 'New artists',
              link: '/artist-charts/top-40-brand-new-artists/#/',
            },
            {
              text: 'Find an artist',
              link: '/artist-search/sort-best_match/paginate-60/',
            },
          ],
        },
        {
          title: 'Ideas',
          links: [
            {
              text: 'Decor inspiration',
              link: '/blog/category/decor-inspiration-tips/',
            },
            {
              text: 'Art glossary',
              link: '/blog/category/art-glossary/',
            },
            {
              text: 'Personal shopping',
              link: '/personal-shopping/',
            },
            {
              text: 'Artfinder trade',
              link: '/trade/',
            },
          ],
        },
        {
          title: 'Sales',
          links: [
            {
              text: `${currencySymbol}500 & under`,
              link: '/art/price_max-500/',
            },
            {
              text: 'All sales',
              link: '/art/in_sale-on/',
            },
            {
              text: 'Free shipping',
              link: '/art/free_shipping-true/',
            },
          ],
          highlights: [
            {
              text: 'Gift cards',
              component: (
                <img
                  loading="lazy"
                  width="150"
                  height="79"
                  alt="Gift cards"
                  aria-label="Gift cards"
                  src="https://d2m7ibezl7l5lt.cloudfront.net/img/v2/megamenu/gift-card.svg"
                />
              ),
              link: '/products/giftcard/',
            },
          ],
        },
      ],
    },
  ];
};
